export const GOOGLE_CLIENT_ID = GOOGLE_OAUth_CLIENT_ID;
export const FB_APP_ID = FB_OAUth_CLIENT_ID;




// WEBPACK FOOTER //
// ./src/utils/socialLogins.js